    <div class="only-owners">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
        <app-invitation-b2b-client-header-partner-infos [invitation]="invitation">
        </app-invitation-b2b-client-header-partner-infos>
        <mat-card class="only-owners__card card">
            <mat-card-content>
                <div class="block-content">
                    <div class="block-content__icon text-center margin-bottom-30">
                        <span class="icon icon-warning warning icon-size-25"></span>
                    </div>
                    <div class="block-content__title text-center margin-bottom-50"
                         [innerHtml]="
                    '<strong>Vous ne pouvez pas</strong> repondre a cette invitation !' | transloco">
                    </div>
                    <div class="block-content__text text-center margin-bottom-50">
                        <div>
                            <strong>{{'Vous ne disposez pas des droits suffisants pour accepter ou refuser cette invitation.' | transloco}}</strong>
                        </div>
                        <div>
                            {{'Seul le responsable legal de l\'organisation $orga$ est autorise a repondre a cette invitation.' | transloco : {
                                orga: invitation.account.organization_name
                            } }}
                        </div>
                    </div>
                    <div class="
                    block-content__buttons
                    text-center">
                        <!-- <a mat-flat-button
                           color="primary"
                           [buttonLoader]="loading"
                           (click)="resendInvitation()">
                            {{ ('Envoyer cette invitation au responsable legal' | transloco) }}
                        </a> -->
                        <div class="margin-top-20">
                            <a color="primary"
                               class="link blue"
                               (click)="changeAccount()">
                                {{ ('Choisir une autre organisation' | transloco) }}
                            </a>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
